import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { Text14, Text16 } from 'atoms/typography';
import { HorizontalDivider } from 'atoms/ui/Divider';
import { useCurrentUserContext } from 'contexts/currentUser';
import { glossary } from 'lib/glossary';

import { UpdateNameDialog } from './UpdateNameDialog';

const StyledButtonBase = styled(ButtonBase)`
  color: var(--c-link);
  text-decoration: underline;
`;

export const UpdateName = () => {
  const { fiatWalletAccountable } = useCurrentUserContext();
  const { firstName, lastName } = fiatWalletAccountable || {};
  const [openDialog, setOpenDialog] = useState(false);
  if (!firstName || !lastName) return null;
  return (
    <>
      <div>
        <Text16>
          <FormattedMessage {...glossary.name} />
        </Text16>
        <Text14 color="var(--c-neutral-600)">
          {firstName} {lastName}
        </Text14>
        <StyledButtonBase onClick={() => setOpenDialog(true)}>
          <Text14 bold color="var(--c-link)">
            <FormattedMessage {...glossary.edit} />
          </Text14>
        </StyledButtonBase>
        <UpdateNameDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
        />
      </div>
      <HorizontalDivider />
    </>
  );
};
